// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SportNav_sidebar__AFuI7","highlightedTitle":"SportNav_highlightedTitle__EfiDN","wrapper":"SportNav_wrapper__E2vdO","withHighlighted":"SportNav_withHighlighted__OTH9_"};